import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { MaterialIcon } from '@dsny/dsny-component-library'
import { StyledModal } from 'components/Modals/Modals.styles'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import { trackEvent } from 'utils/segmentService'
import {
  ActionButton,
  Actions,
  BodyText,
  CloseButton,
  CopyBlock,
  ErrorText,
  ModalContent,
  ModalHeader,
  Title
} from './RemovePlaylistModal.styles'

const RemovePlaylistModal = ({
  hasError = false,
  isLoading = false,
  isOpen,
  onCancel,
  onConfirm,
  playlist = null
}) => {
  const { t } = useTranslation()
  const isMobile = useMobileMediaQuery()
  const cancelButton = (
    <ActionButton
      key="cancel"
      disabled={isLoading}
      mode="dark"
      setting="player"
      type="button"
      variant="secondary"
      onClick={onCancel}>
      {t('general.cancel')}
    </ActionButton>
  )
  const removeButton = (
    <ActionButton
      key="remove"
      disabled={isLoading}
      mode="dark"
      setting="player"
      type="button"
      variant="primary"
      onClick={onConfirm}>
      {isLoading ? t('general.loading') : t('playlist.remove-playlist')}
    </ActionButton>
  )

  return (
    <StyledModal
      $isMobile={isMobile}
      analyticsModalType="playlist_removal"
      bodyStyles={{ width: '100%' }}
      containerStyles={{
        boxSizing: 'border-box',
        maxWidth: 'calc(100vw - 32px)',
        overflow: 'hidden',
        padding: isMobile ? '24px 12px' : '32px',
        width: isMobile ? '288px' : '624px'
      }}
      isEscKeypressDisabled={isLoading}
      isMaskClickDisabled={isLoading}
      isOpen={isOpen}
      trackEvent={trackEvent}
      onClose={onCancel}>
      <ModalContent aria-busy={isLoading}>
        <CopyBlock>
          <ModalHeader>
            <Title>{t('playlist.remove-playlist-title')}</Title>
            <CloseButton
              aria-label={t('general.cancel')}
              disabled={isLoading}
              type="button"
              onClick={onCancel}>
              <MaterialIcon name="X" color="currentColor" />
            </CloseButton>
          </ModalHeader>
          <BodyText>
            {t('playlist.remove-playlist-message', {
              name: playlist?.name || ''
            })}
          </BodyText>
          {hasError && (
            <ErrorText role="alert">
              {t('playlist.remove-error-message')}
            </ErrorText>
          )}
        </CopyBlock>
        <Actions>
          {isMobile
            ? [removeButton, cancelButton]
            : [cancelButton, removeButton]}
        </Actions>
      </ModalContent>
    </StyledModal>
  )
}

RemovePlaylistModal.propTypes = {
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  playlist: PropTypes.shape({ name: PropTypes.string })
}

export default RemovePlaylistModal
